import React from 'react';
import { FontAwesomeIcon, icons } from './IconComponents';
export default ({ name, className, onClick = () => { } }) => {
    if (name.startsWith('font-awesome-')) {
        return (React.createElement(FontAwesomeIcon, { name: name, className: className, onClick: () => onClick() }));
    }
    if (icons[name]) {
        return icons[name]({ className: className, onClick: onClick });
    }
    return null;
};
